<div class="page-container center-block" style="min-height:188.38330078125px">
  <!--Page content -->
  <div class="page-content">
    <div class="panel panel-flat shadow" style="border: none">
      <div class="panel-body">
        <h1 style="text-align: center" translate>Document Request</h1>
        <br>
        <div class="col-sm-8 col-sm-offset-2">
          <p translate>Please enter the information of the recipients to sign. A request to sign with the E-signature will be sent to the relevant persons. The document can be signed with USB e-signature or Turkcell/TurkTelekom/Vodafone mobile signature.</p>
          <br>
          <p>{{publicLink?.description}}</p>
          <br>
          <form #form="ngForm" novalidate>
            <div *ngIf="publicLink?.recipient1Id" class="row">
              <h2>{{publicLink?.recipient1Nick}} {{infoTranslation}}</h2>
              <br>
              <div class="form-group row">
                <div class="form-group position">
                  <label class="col-sm-4 text-right"><strong translate>Name</strong></label>
                  <div class="col-sm-6 text-left">
                    <input type="text" class="form-control" [(ngModel)]="params.recipient1Name" [placeholder]="translate.instant('Name')" name="recipient1Name" #recipient1Name="ngModel" required pattern="^[0-9a-zA-ZsçÇöÖşŞıİğĞüÜ',. -]+$">
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="form-group position">
                  <label class="col-sm-4 text-right"><strong translate>Email</strong></label>
                  <div class="col-sm-6 text-left">
                    <input type="email" class="form-control" [(ngModel)]="params.recipient1Email" placeholder="john@doe.com" name="recipient1Email" #recipient1Email="ngModel" required minlength="5" pattern="^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$">
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="form-group position">
                  <label class="col-sm-4 text-right"><strong translate>Citizen ID</strong></label>
                  <div class="col-sm-6 text-left">
                    <input type="text" class="form-control" [(ngModel)]="params.recipient1CitizenId" [placeholder]="translate.instant('Citizen ID (Optional)')" name="recipient1CitizenId" #recipient1CitizenId="ngModel" minlength="11" maxlength="11" pattern="[0-9]+">
                  </div>
                </div>
              </div>
              <br>
            </div>
            <div *ngIf="publicLink?.recipient2Id">
              <h2>{{publicLink?.recipient2Nick}} {{infoTranslation}}</h2>
              <br>
              <div class="form-group row">
                <div class="form-group position">
                  <label class="col-sm-4 text-right"><strong translate>Name</strong></label>
                  <div class="col-sm-6 text-left">
                    <input type="text" class="form-control" [(ngModel)]="params.recipient2Name" [placeholder]="translate.instant('Name')" name="recipient2Name" #recipient2Name="ngModel" required pattern="^[0-9a-zA-ZsçÇöÖşŞıİğĞüÜ',. -]+$">
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="form-group position">
                  <label class="col-sm-4 text-right"><strong translate>Email</strong></label>
                  <div class="col-sm-6 text-left">
                    <input type="email" class="form-control" [(ngModel)]="params.recipient2Email" [placeholder]="translate.instant('john@doe.com')" name="recipient2Email" #recipient2Email="ngModel" required minlength="5" pattern="^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$">
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="form-group position">
                  <label class="col-sm-4 text-right"><strong translate>Citizen ID</strong></label>
                  <div class="col-sm-6 text-left">
                    <input type="text" class="form-control" [(ngModel)]="params.recipient2CitizenId" [placeholder]="translate.instant('Citizen ID (Optional)')"name="recipient2CitizenId" #recipient2CitizenId="ngModel" minlength="11" maxlength="11" pattern="[0-9]+">
                  </div>
                </div>
              </div>
              <br>
            </div>
            <div *ngIf="publicLink?.recipient3Id">
              <h2>{{publicLink?.recipient3Nick}} {{infoTranslation}}</h2>
              <br>
              <div class="form-group row">
                <div class="form-group position">
                  <label class="col-sm-4 text-right"><strong translate>Name</strong></label>
                  <div class="col-sm-6 text-left">
                    <input type="text" class="form-control" [(ngModel)]="params.recipient3Name" [placeholder]="translate.instant('Name')" name="recipient3Name" #recipient3Name="ngModel" required pattern="^[0-9a-zA-ZsçÇöÖşŞıİğĞüÜ',. -]+$">
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="form-group position">
                  <label class="col-sm-4 text-right"><strong translate>Email</strong></label>
                  <div class="col-sm-6 text-left">
                    <input type="email" class="form-control" [(ngModel)]="params.recipient3Email" [placeholder]="translate.instant('john@doe.com')" name="recipient3Email" #recipient3Email="ngModel" required minlength="5" pattern="^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$">
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="form-group position">
                  <label class="col-sm-4 text-right"><strong translate>Citizen ID</strong></label>
                  <div class="col-sm-6 text-left">
                    <input type="text" class="form-control" [(ngModel)]="params.recipient3CitizenId" [placeholder]="translate.instant('Citizen ID (Optional)')" name="recipient3CitizenId" #recipient3CitizenId="ngModel" minlength="11" maxlength="11" pattern="[0-9]+">
                  </div>
                </div>
              </div>
              <br>
            </div>
            <div *ngIf="publicLink?.recipient4Id">
              <h2>{{publicLink?.recipient4Nick}} {{infoTranslation}}</h2>
              <br>
              <div class="form-group row">
                <div class="form-group position">
                  <label class="col-sm-4 text-right"><strong translate>Name</strong></label>
                  <div class="col-sm-6 text-left">
                    <input type="text" class="form-control" [(ngModel)]="params.recipient4Name" [placeholder]="translate.instant('Name')" name="recipient4Name" #recipient4Name="ngModel" required pattern="^[0-9a-zA-ZsçÇöÖşŞıİğĞüÜ',. -]+$">
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="form-group position">
                  <label class="col-sm-4 text-right"><strong translate>Email</strong></label>
                  <div class="col-sm-6 text-left">
                    <input type="email" class="form-control" [(ngModel)]="params.recipient4Email" [placeholder]="translate.instant('john@doe.com')" name="recipient4Email" #recipient4Email="ngModel" required minlength="5" pattern="^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$">
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <div class="form-group position">
                  <label class="col-sm-4 text-right"><strong translate>Citizen ID</strong></label>
                  <div class="col-sm-6 text-left">
                    <input type="text" class="form-control" [(ngModel)]="params.recipient4CitizenId" [placeholder]="translate.instant('Citizen ID (Optional)')" name="recipient4CitizenId" #recipient4CitizenId="ngModel" minlength="11" maxlength="11" pattern="[0-9]+">
                  </div>
                </div>
              </div>
              <br>
            </div>
            <br>
            <button type="button" class="btn btn-default active pull-right" (click)="sendDocumentForSing(form.value)" [disabled]="!form.valid" data-dismiss="modal" translate>Send document for signature</button>
          </form>
        </div>
      </div>
      <br>
    </div>
  </div>
</div>
